module.exports = __webpack_public_path__ + "assets/img/en.587a5928.svg";